'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollLock = require('./ScrollLock');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScrollLock).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-scrolllock/dist/index.js
// module id = 6280
// module chunks = 39